import React, { useEffect, useState } from 'react';

import * as css from './css/checkbox';

function Checkbox(props) {
  const { id, className, checked:propsChecked, setChecked:propsSetChecked } = props;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (propsChecked) {
      setChecked(true);
    }
  });

  function onChange(e){
    setChecked(!checked);
    propsSetChecked(!checked);
  }

  return (
    <>
      <css.Checkbox id={id} checked={checked} onChange={onChange}/>
      <css.Label className={className} for={id} />
    </>
  );
}

export default Checkbox;
